module.exports = __WEBPACK_EXTERNAL_MODULE_388__;


//////////////////
// WEBPACK FOOTER
// external "React"
// module id = 388
// module chunks = 6 8 9 10